import React, { Component } from 'react';
import Cognito from "src/js/Cognito.js";
import { BrowserRouter as Router, Switch} from 'react-router-dom';
import DriverRouter from 'src/component/Router/DriverRouter';
import Config from 'src/config.json';
import Modal from 'src/js/Modal';
import ErrorBoundary from 'src/js/ErrorBoundary';
import LoginRouter from 'src/component/Router/LoginRouter';

class App extends Component {

    constructor() {
        super();
        this.state = {
            cognitoUser: [],
            isAospBrowser: false,
            isLocalStorage: true
        }

        this.assignUser = this.assignUser.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.getCookieValue = this.getCookieValue.bind(this);
        this.setCookie = this.setCookie.bind(this);
        this.updateCookie = this.updateCookie.bind(this);
        this.isLocalStorageAvailable = this.isLocalStorageAvailable.bind(this);
    }

    componentDidMount() {
        window.addEventListener("beforeunload", this.onUnload)
    }

    isLocalStorageAvailable() {
        // ローカルストレージが利用可能か確認
        try {
            let valueToStore = 'test';
            let key = 'key';
            localStorage.setItem(key, valueToStore);
            let recoverdValue = window.localStorage.getItem(key);
            localStorage.removeItem(key);

            return recoverdValue === valueToStore;
        } catch (e) {
            return false;
        }
    }

    onUnload(event) {
        // 画面が閉じられたらクッキーの認証フラグを削除
        let date = new Date();
        date.setTime(date.getTime() - 1);
    }

    getCookieValue(name) {
        let result = null;
        let cookieName = name + "=";
        let allCookies = document.cookie;
        let position = allCookies.indexOf(cookieName);
        if (position !== -1) {
            let startIndex = position + cookieName.length;

            let endIndex = allCookies.indexOf(';', startIndex);
            if (endIndex === -1) {
                endIndex = allCookies.length;
            }
            result = decodeURIComponent(
                allCookies.substring(startIndex, endIndex));
        }
        return result;
    }

    updateCookie() {
        // 1分ごとにクッキーを更新
        setInterval(this.setCookie, 60000)
    }

    setCookie() {
        // クッキーの認証フラグが存在するか
        if (this.getCookieValue(Config.COOKIE.AUTH_KEY_NAME)) {
            // ある場合は有効期限を更新
            document.cookie = Config.COOKIE.AUTH_KEY_NAME + '=true; path=/; max-age=600';
        }
    }

    componentWillMount() {

        // ローカルストレージが利用できない場合はエラーを出す
        if (!this.isLocalStorageAvailable()) {
            this.setState({
                isLocalStorage: false
            });
        } else {
            this.setState({
                isLocalStorage: true
            });
        }

        this.updateCookie();

        // 認証チェック
        if (Cognito.signInCheck()) {
            // 認証確認クッキーの有効期限が切れていた場合
            if (!this.getCookieValue(Config.COOKIE.AUTH_KEY_NAME)) {
                // サインアウト
                Cognito.signOut();
                //ローカルストレージクリア
                localStorage.clear();
                // ログイン画面へ遷移(コンポーネントをリセットするために画面更新を含む)
                window.location.href = '/login';
            }
            // 認証済みで画面更新された時は、ユーザとグループを再セット
            this.assignUser();
        }

        // Android標準ブラウザ判定
        let ua = navigator.userAgent;
        if ((/Android/.test(ua) && /Linux; U;/.test(ua) && !/Chrome/.test(ua)) ||
            (/Android/.test(ua) && /Chrome/.test(ua) && /Version/.test(ua)) ||
            (/Android/.test(ua) && /Chrome/.test(ua) && /SamsungBrowser/.test(ua))) {
            // 警告を出すためにフラグを真にする
            this.setState({
                isAospBrowser: true,
            })
        }
    }

    // ユーザをセット
    assignUser() {
        this.setState({
            cognitoUser: Cognito.getCognitoUser(),
        });
    }

    render() {
        return (
            <Router>
                <div>
                    <ErrorBoundary>
                        {(() => {
                            if (!this.state.isLocalStorage) {
                                return (<Modal isAospBrowser={this.state.isAospBrowser} isLocalStorage={this.state.isLocalStorage} />);
                            }
                        })()}
                        <Switch>
                            {(() => {
                                if (this.state.cognitoUser.length !== 0) {
                                    return <DriverRouter />;
                                } else {
                                    return <LoginRouter assignUser={this.assignUser}/>;
                                }
                            })()}
                        </Switch>
                    </ErrorBoundary>
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js